import React from 'react';
import FormDefault from '~/components/FormDefault';
import Search from '~/components/Search';
import { Container } from './styles';
import { useAdministradora } from './hooks/useAdministradora';
import DefaultLoader from '~/components/DefaultLoader';
import { Tab, Tabs } from 'react-bootstrap';
import { AbaGeral } from './abas/AbaGeral';
import { AbaBandeiras } from './abas/AbaBandeiras';

export const AdministradoraContent: React.FC = () => {
  const {
    formGeral: { watch },
    onSubmit,
    setShowSearch,
    showSearch,
    isUpdate,
    setUpdate,
    loader,
    tab,
    setTab,
    resetFormData,
    onRowClick,
    onNew,
  } = useAdministradora();

  if (loader) {
    return (
      <Container>
        <DefaultLoader />
      </Container>
    );
  }

  return (
    <Container>
      {showSearch && (
        <Search codTela={316} newData={onNew} onRowClick={onRowClick} />
      )}
      {!showSearch && (
        <FormDefault
          title={
            watch('name')
              ? `Administradora - ${watch('name')}`
              : `Cadastro de Administradora`
          }
          codTela={316}
          codigoRegistro={[
            {
              value: watch('cod_administradora'),
              des_campo: 'Código do Registro',
            },
          ]}
          onSave={async () => {
            await onSubmit();
          }}
          onCancel={() => {
            resetFormData();
            setShowSearch(true);
          }}
          isUpdate={isUpdate}
          onNew={onNew}
          onDelete={() => []}
          onClearFields={() => resetFormData()}
          onReturnSearch={() => {
            resetFormData();
            setUpdate(false);
            setShowSearch(true);
          }}
          isDelete={false}
        >
          <Tabs
            id="controlled-tab-administradora"
            activeKey={tab}
            onSelect={(k) => setTab(k || 'geral')}
            style={{ marginTop: '20px' }}
          >
            <Tab eventKey="geral" title="Geral">
              <AbaGeral />
            </Tab>
            <Tab eventKey="bandeiras" title="Bandeiras">
              <AbaBandeiras />
            </Tab>
          </Tabs>
        </FormDefault>
      )}
    </Container>
  );
};
